import React from 'react'
import { css } from 'aphrodite'
import { Link } from 'react-router-dom'
import { Container, Row, Col, FormGroup, Input } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import Sitemap from '../partials/Sitemap'
import ResponseAlert from '../partials/ResponseAlert'

import style from './style'

const sitemapOptions = [
  { url: '/auth', title: 'Auth' },
  { url: '/login', title: 'Login' }
]

@inject('Auth')
@observer
export class Login extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editor: {
        email: '',
        password: ''
      }
    }
  }

  onInputChange(e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  onFormSubmit(e) {
    e.preventDefault()
    this.props.Auth.login(this.state.editor)
      .then(console.log)
      .catch(console.warn)
  }

  render() {
    return [
      <Sitemap key={0} sitemap={sitemapOptions} />,
      <section key={1} className={css(style.main.section)}>
        <Container>
          <Row className={`d-flex align-items-center justify-content-center`}>
            <Col
              tag="form"
              xs="12"
              sm="6"
              className={css(style.box.wrapper)}
              onSubmit={this.onFormSubmit.bind(this)}
            >
              <Row tag="header">
                <Col className={css(style.box.header)}>
                  I'm a returning customer
                </Col>
              </Row>
              <Row className={css(style.form.wrapper)}>
                <Col xs="12">
                  {!this.props.Auth.response.login ? null : (
                    <ResponseAlert
                      statusCode={this.props.Auth.response.login.statusCode}
                      alert={
                        +this.props.Auth.response.login.statusCode >= 400
                          ? 'danger'
                          : 'success'
                      }
                      content={(this.props.Auth.response.login || {}).data.message}
                    />
                  )}
                </Col>
                <Col xs="12">
                  <FormGroup className={css(style.form.formGroup)}>
                    <Input
                      type="text"
                      name="email"
                      autoComplete="email"
                      value={this.state.editor.email}
                      placeholder="Email"
                      onChange={this.onInputChange.bind(this)}
                      className={css(
                        style.form.input,
                        style.form.singleRowInput
                      )}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <FormGroup className={css(style.form.formGroup)}>
                    <Input
                      type="password"
                      autoComplete="password"
                      name="password"
                      value={this.state.editor.password}
                      placeholder="Password"
                      onChange={this.onInputChange.bind(this)}
                      className={css(
                        style.form.input,
                        style.form.singleRowInput
                      )}
                    />
                  </FormGroup>
                </Col>
                <Col xs="12">
                  <Link to="/auth/remind" className={css(style.box.link)}>
                    Forgot Password?
                  </Link>
                </Col>
              </Row>
              <Row tag="footer">
                <Col
                  className={`d-flex justify-content-end ${css(
                    style.box.footer
                  )}`}
                >
                  <input
                    type="submit"
                    value="Log in"
                    className={css(style.form.submit)}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    ]
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/components/Login/index.js